import axiosClient from "../../../api/apiClient";

interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    teacher_id: string;
}

interface IOptionsStudents {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    work_plan_id: string;
    classroom_id: string;
    teacher_id: string;
}

export const APIPostWorkPlan = (data: object) => {
    return axiosClient.post(`/work-plans/store`, data);
};

export const APIGetWorkPlans = (options: IOptions) => {
    let sort = "";
    let search = "";
    let teacherId = "";
    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("teacher_id" )) {
        if(options.teacher_id !== undefined) {
            teacherId = "&teacher_id=" + options.teacher_id;
        }
    }

    return axiosClient.post(`/work-plans${options.page}${search}${sort}${teacherId}`);
};

export const APIPostWorkPlanStudents = (options: IOptionsStudents) => {
    let sort = "";
    let search = "";
    let classroomId = "";
    let workPlanId = "";
    let teacherId = "";
    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("work_plan_id" )) {
        if(options.work_plan_id !== undefined) {
            workPlanId = "&work_plan_id=" + options.work_plan_id;
        }
    }

    if (options.hasOwnProperty("teacher_id" )) {
        if(options.teacher_id !== undefined) {
            teacherId = "&teacher_id=" + options.teacher_id;
        }
    }

    if (options.hasOwnProperty("classroom_id" )) {
        if(options.classroom_id !== undefined) {
            classroomId = "&classroom_id=" + options.classroom_id;
        }
    }

    return axiosClient.post(`work-plans/students${options.page}${search}${sort}${teacherId}${classroomId}${workPlanId}`);
};